<div class="meta-data-overview-tables container-fluid">

    <!-- header -->
    <div class="upload-header upload-padding">
        <div class="upload-header-centered">
            <div class="upload-header-title">UPLOADS</div>
            <div class="upload-header-subtitle">ASTRONOMICAL PREDICTIONS</div>
        </div>
    </div>

    <!-- content -->
    <div class="upload-padding">
        <!-- row search-bar input and upload-file button -->
        <div class="row justify-content-between row-top-margin row-0-margin">
            <!-- search bar -->
            <div class="col-md-4 col-0-padding">
                <div class="float-left" id="search-bar">
                    <div class="input-group">
            <span class="input-group-addon">
              <button id="search-button" type="submit">
                <i aria-hidden="true" class="fa fa-search"></i>
              </button>
            </span>
                        <input (ngModelChange)="this.filterMetaData();this.updateMetaDataArray()" [(ngModel)]="searchTerm"
                               class="form-control" id="search-input"
                               placeholder="Search file"
                               type="text">
                    </div>
                </div>
            </div>
            <!-- upload file button -->

            <div *ngIf="this.rights.get('update')" class="col-md-4 col-0-padding">
                <div class="float-right">
                    <button (click)="openModal()" class="btn float-right" id="upload-file-button" type="button">
                        UPLOAD
                        <span>
                      <i aria-hidden="true" class="fa fa-upload"></i>
                           </span>
                    </button>
                </div>
            </div>
            <div class="float-md-left">
                <button (click)="refreshList()" class="btn float-left" id="update-table-button" type="button">
                    UPDATE TABLE
                </button>
            </div>
        </div>
        <!-- row table -->

        <ng-container *ngIf="isSuccessfullUploaded === true; else uploadFailed">
            <div [hidden]="hideUploadStatusMessage" class="upload-result-message upload-succes">
                <p class="upload-succes"><i aria-hidden="true" class="fa fa-times"></i>{{ fileName }}
                    was succesfully sent for processing. This may take a while, so please update
                    the table after some time.</p>
            </div>
        </ng-container>
        <ng-template #uploadFailed>
            <div [hidden]="hideUploadStatusMessage" class="upload-result-message failed-upload">
                <p class="upload-failed"><i aria-hidden="true" class="fa fa-times"></i> {{ fileName }}
                    could not be sent for processing. Something might be wrong with the
                    file or a communication error might have occurred.</p>
            </div>
        </ng-template>

        <div class="row row-top-margin row-0-margin" id="row-metadata-table">
            <app-table
                    [tableAttributes]="tableProperties"
                    [tableRowObjects]="displayedMetaData"
                    id="astronomical-predictions-table">
            </app-table>
        </div>
        <!-- row pagination -->
        <div class="row row-0-margin" id="pagination">
            <div>
      <span>
        Items per page:
      </span>
                <span class="selector">
        <select (ngModelChange)="changeStep(this.step)" [(ngModel)]="this.step" id="step-select">
          <option *ngFor="let step of steps" [ngValue]="step">
            {{ step }}
          </option>
        </select>
      <i aria-hidden="true" class="fa fa-chevron-down"></i>
      </span>
                <span>
        | {{ this.filteredMetaData.length === 0 ? 0 : this.step * this.page + 1 }}
                    - {{ this.filteredMetaData.length < (this.page + 1) * this.step ? this.filteredMetaData.length : (this.page + 1) * this.step }}
                    of {{ this.filteredMetaData.length }} items
      </span>
            </div>
            <div class="pagination-right">
                <span
                        class="numberOfPages">{{ this.filteredMetaData.length === 0 ? 0 : this.page + 1 }} of {{ this.maxPage }}
                    page(s)</span>
                <button (click)="changePage(this.page -1)" [disabled]="this.isPreviousButtonDisabled" class="pageSelector">
                    <i aria-hidden="true" class="fa fa-angle-left pageIcon"></i>
                </button>
                <span class="selector">
        <select (ngModelChange)="changePage(this.page)" [(ngModel)]="this.page" id="page-select">
          <option *ngFor="let i of this.pages" [ngValue]="i">
            {{ i + 1 }}
          </option>
        </select>
      </span>
                <button (click)="changePage(this.page +1)" [disabled]="this.isNextButtonDisabled" class="pageSelector">
                    <i aria-hidden="true" class="fa fa-angle-right pageIcon"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showModal" class="custom-modal-backdrop">
    <div class="custom-modal">
        <div class="modal-content">
            <div class="modal-header">
                <button (click)="closeModal()" class="close close-button" type="button">
                    <span aria-hidden="true" class="cross">&times;</span>
                </button>
                <p class="modal-title">UPLOAD ASTRONOMICAL PREDICTIONS</p>
            </div>

            <div class="modal-body" id="upload-modal">
                <p class="modal-sub-title">You can upload and import one file at a time.</p>

                <form (ngSubmit)="uploadFile()" [formGroup]="uploadFileForm" id="uploadFile" novalidate>
                    <p class="form-header">File type</p>
                    <label>
                        <input (change)="onFileTypeChange($event)" class="form-check-input" formControlName="fileType" name="fileType"
                               type="radio"
                               value="waterLevel"> Water level
                    </label>

                    <label>
                        <input (change)="onFileTypeChange($event)" class="form-check-input" formControlName="fileType" name="fileType"
                               type="radio"
                               value="highAndLowWaterMarks"> High and low water
                    </label>

                    <p class="form-header">Filename</p>
                    <input (change)="onFileChange($event)" class="file-upload" formControlName="file" id="file-input"
                           name="file-input" placeholder="Upload file..." type="file"/>
                </form>
            </div>

            <div class="modal-footer">
                <button (click)="closeModal()" class="btn btn-secondary cancel-button" type="button">CANCEL</button>
                <button (click)="uploadFile()" [disabled]="!activeFile || !activeFileType"
                        class="btn btn-primary upload-button" type="submit">UPLOAD
                </button>
            </div>
        </div>
    </div>
</div>
